export interface IContactRms {
  id?: number;
  firstName?: string | null;
  lastName?: string | null;
  company?: string | null;
  kvk?: number | null;
  email?: string | null;
  phoneNumber?: number | null;
  message?: string | null;
  fileContactPath?: string | null;
  consent?: boolean | null;
  checkSendEmail?: string | null;
  type?: string | null;
}

export const defaultValue: Readonly<IContactRms> = {
  consent: false,
};
